var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("任务调度列表")]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }